package org.hs_soft.runmynesto.pages.components.dialog.dialog

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.delay
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.virtual_card.virtual_card_config.GetVirtualCardConfig
import org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.menu_card_model.MenuCardModel
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.multiple
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement
import org.w3c.files.File


@Composable
fun MenuCardAIDialog(
    windowSizeMode: WindowSizeModeEnum,
    menuCardAIGenerated:MenuCardModel,
    menuCardPDFFilesUploaded: Int,
    onAddPDFFile: (Int) -> Unit,
    menuCardImageFilesUploaded: Int,
    onAddImageFile: (Int) -> Unit,
    onMenuCardFilesSelect: (List<File>) -> Unit,
    loading:Boolean,
    info: GetVirtualCardConfig?,
    onBackgroundClick: () -> Unit,
    onCancelGenerateMenuCardClick: () -> Unit,
    onGenerateMenuCardClick: (String, List<File>) -> Unit,
    menuCardSelectedFiles: List<File>,
)
{
    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onBackgroundClick()
            }
    ){

        Column(
            modifier = Modifier
                .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                }
                .align(Alignment.Center)
                .width(Dimen.verticalDialogWidth)
                .height(Dimen.verticalAIDialogHeight)
                .generalDialogSetting()
            ,
            horizontalAlignment = Alignment.CenterHorizontally
        ){

            Header()

            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(Dimen.mediumPadding)
            )
            {
                GenerateMenuCard(
                    onGenerateMenuCardClick = { email, menuCard ->
                        onGenerateMenuCardClick(email, menuCard)
                    },
                    menuCardPDFFilesUploaded = menuCardPDFFilesUploaded,
                    menuCardImageFilesUploaded = menuCardImageFilesUploaded,
                    onAddPDFFile = {
                        onAddPDFFile(it)
                    },
                    onAddImageFile = {
                        onAddImageFile(it)
                    },
                    menuCardSelectedFiles = menuCardSelectedFiles,
                    onMenuCardFilesSelect = onMenuCardFilesSelect
                )

                if (loading){
                    LoadingComponent(
                        loading=loading,
                        menuCardPDFFilesUploaded = menuCardPDFFilesUploaded,
                        menuCardImageFilesUploaded = menuCardImageFilesUploaded
                    )
                }


                Spacer()

                Row(
                    modifier = Modifier.fillMaxWidth()
                )
                {
                    CustomButton(
                        windowSizeMode =windowSizeMode,
                        title = Strings.current().cancel,
                        buttonType = ButtonTypes.OUTLINED,
                        onButtonClick ={
                            onCancelGenerateMenuCardClick()
                        },
                    )

                    Spacer()


                    CustomButton(
                        windowSizeMode =windowSizeMode,
                        isClickable =menuCardSelectedFiles.isNotEmpty(),
                        title = Strings.current().confirm,
                        loading = loading,
                        buttonType = ButtonTypes.CONTAINED,
                        onButtonClick ={
                            onGenerateMenuCardClick(info!!.issuerEmail ?: "", menuCardSelectedFiles)
                        },
                    )
                }


            }


        }




    }



}


@Composable
private fun LoadingComponent(
    loading: Boolean,
    menuCardPDFFilesUploaded: Int,
    menuCardImageFilesUploaded: Int
) {
    var currentStage by remember { mutableStateOf(0) }

    val stageMessages = listOf(
        Strings.current().uploadFilesProcess,
        Strings.current().generateMenuCardProcess,
        Strings.current().clearMenuCardProcess,
        Strings.current().prepareResultProcess
    )
    val stageDelays = listOf(
        if (menuCardPDFFilesUploaded != 0 || menuCardImageFilesUploaded > 1)
            Constants.delayDefaultProcess * (menuCardPDFFilesUploaded + 1)
            else Constants.delayDefaultProcess / 2,
        if (menuCardPDFFilesUploaded != 0 || menuCardImageFilesUploaded > 1)
            Constants.delayGenerateMenuCard * 2 else Constants.delayGenerateMenuCard,
        Constants.delayDefaultProcess,
        Constants.timeout * 10
    )

    LaunchedEffect(currentStage, loading) {
        while (loading && currentStage < stageMessages.size) {
            delay(stageDelays[currentStage])
            currentStage = (currentStage + 1) % (stageMessages.size + 1)
        }
    }

    if (loading && currentStage < stageMessages.size) {
        val progressMessage = "${currentStage}/${stageMessages.size}" +
                " ${Strings.current().menuCardProgressMessage}"
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .margin(top = Dimen.normalPadding),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                text = stageMessages[currentStage],
                modifier = Modifier
                    .fontSize(FontSizes.mediumFontSize)
                    .fontFamily(FontFamily.Jakarta)
                    .fontWeight(FontWeight.Medium)
                    .color(Theme.PrimaryDark.rgb)
                    .padding(leftRight = Dimen.smallPadding)
            )
            SpanText(
                text = progressMessage,
                modifier = Modifier
                    .fontSize(FontSizes.mediumFontSize)
                    .fontFamily(FontFamily.Jakarta)
                    .fontWeight(FontWeight.Medium)
                    .color(Theme.PrimaryDark.rgb)
                    .padding(top = Dimen.smallPadding)
            )
        }
    }
}


@Composable
fun GenerateMenuCard(
    onGenerateMenuCardClick: (String, List<File>) -> Unit,
    menuCardPDFFilesUploaded: Int,
    menuCardImageFilesUploaded: Int,
    onAddImageFile: (Int) -> Unit,
    onAddPDFFile: (Int) -> Unit,
    menuCardSelectedFiles: List<File>,
    onMenuCardFilesSelect: (List<File>) -> Unit,
) {
    var selectedFiles by remember { mutableStateOf(menuCardSelectedFiles) }

    LaunchedEffect(menuCardSelectedFiles) {
        selectedFiles = menuCardSelectedFiles
    }

    Column {
        var inputElement by remember { mutableStateOf<HTMLInputElement?>(null) }
        val fileCountText = if (selectedFiles.isEmpty()) {
            Strings.current().menuCardSelectFilesMessages
        } else {
            "${selectedFiles.size} ${Strings.current().filesChosen}"
        }



        Input(type = InputType.File, attrs = {
            ref {
                    element -> inputElement = element
                onDispose { }
            }
            multiple()
            onInput {
                val input = it.target as HTMLInputElement
                val files = input.files
                val fileList = selectedFiles.toMutableList()
                if (files != null) {
                    for (i in 0 until files.length) {
                        val file = files.item(i)
                        if (file != null) {
                            val extension = file.name.substringAfterLast('.', "")
                            if (extension == "pdf") {
                                onAddPDFFile(menuCardPDFFilesUploaded + 1)
                            } else {
                                onAddImageFile(menuCardImageFilesUploaded + 1)
                            }
                            fileList.add(file)
                            onMenuCardFilesSelect(fileList)
                        }
                    }
                }
                selectedFiles = fileList
                input.value = ""
            }
            margin(top = Dimen.smallPadding)
        })

        SpanText(
            text = fileCountText,
            modifier = Modifier
                .width(Dimen.selectRectPhoneWidth)
                .textAlign(TextAlign.Start)
                .fontSize(FontSizes.normalFontSize)
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.Normal)
                .margin(topBottom = Dimen.smallPadding)
                .color(Theme.Gray3E.rgb)
                .whiteSpace(WhiteSpace.PreWrap)
                .textOverflow(TextOverflow.Ellipsis)
        )

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .maxHeight(Dimen.menuCardAIFilesUploadHeight)
                .overflow(Overflow.Auto)
        ) {
            Column {
                selectedFiles.forEachIndexed { index, file ->
                    Div(attrs = {
                        style {
                            marginTop(Dimen.semiNormalPadding)
                            marginBottom(Dimen.semiNormalPadding)
                        }
                    }) {
                        SpanText(
                            text = file.name,
                            modifier = Modifier
                                .width(Dimen.selectRectPhoneWidth)
                                .textAlign(TextAlign.Start)
                                .fontSize(FontSizes.mediumFontSize)
                                .fontFamily(FontFamily.Jakarta)
                                .fontWeight(FontWeight.Medium)
                                .color(Theme.TextPrimary.rgb)
                                .whiteSpace(WhiteSpace.PreWrap)
                                .textOverflow(TextOverflow.Ellipsis)
                                .margin(bottom = Dimen.smallPadding)
                        )
                        SpanText(" ")
                        Button(attrs = {
                            style { marginLeft(Dimen.normalPadding) }
                            onClick {
                                val extension = file.name.substringAfterLast('.', "")
                                if (extension == "pdf") {
                                    onAddPDFFile(menuCardPDFFilesUploaded - 1)
                                } else {
                                    onAddImageFile(menuCardImageFilesUploaded - 1)
                                }
                                selectedFiles = selectedFiles.toMutableList().apply { removeAt(index) }
                                onMenuCardFilesSelect(selectedFiles)
                            }
                        }) {
                            Text(Strings.current().remove)
                        }
                    }
                }
            }
        }
    }
}


@Composable
private fun Header() {
    Column(
        modifier = Modifier.fillMaxWidth()
    )
    {
        SpanText(
            text = Strings.current().newMenuCard,
            modifier = Modifier
                .margin(
                    leftRight = Dimen.mediumPadding,
                    topBottom = Dimen.normalPadding,
                )
                .cursor(Cursor.Pointer)
                .fontSize(FontSizes.mediumFontSize)
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.Medium)
                .color(Theme.TextPrimary.rgb)
        )

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(Dimen.smallThickness)
                .backgroundColor(Theme.ActionDisabledBackground.rgb)
        )
    }

}